import applicationUI from 'state/reducers/applicationUI';
import article from 'state/reducers/article';
import businessOnboardingPage from 'state/reducers/businessOnboardingPage';
import campaignPage from 'state/reducers/campaignPage';
import jobPostings from 'state/reducers/jobPostings';
import tag from 'state/reducers/tag';
import topic from 'state/reducers/topic';
import genericPage from 'state/reducers/genericPage';
import globalSettings from 'state/reducers/globalSettings';
import marketingPage from 'state/reducers/marketingPage';
import status from 'state/reducers/status';
import authorPage from 'state/reducers/authorPage';
import showcasePage from 'state/reducers/showcasePage';

export default {
  applicationUI,
  article,
  businessOnboardingPage,
  campaignPage,
  jobPostings,
  tag,
  topic,
  genericPage,
  globalSettings,
  marketingPage,
  status,
  authorPage,
  showcasePage,
};
